import { SourceMapConsumer } from 'source-map-js';

export interface StackInfo {
  chunkName: string;
  line: number;
  column: number;
}

/**
 * Extracts chunk name, line, and column from a minified stack trace.
 */
export function extractChunkInfo(stack: string): StackInfo | null {
  const regex = /(chunk-[A-Z0-9]+)\.js:(\d+):(\d+)/i;
  const match = stack.match(regex);
  if (match) {
    return {
      chunkName: match[1],
      line: parseInt(match[2], 10),
      column: parseInt(match[3], 10)
    };
  }
  return null;
}

/**
 * Decode the minified position to original TypeScript source using source map.
 * Optional caching can be added to improve performance.
 */
const sourceMapCache = new Map<string, SourceMapConsumer>();

export async function decode(chunkName: string, line: number, column: number) {
  try {
    let consumer = sourceMapCache.get(chunkName);
    if (!consumer) {
      const response = await fetch(`/SetupSpa/${chunkName}.js.map`);
      if (!response.ok) {
        console.warn(`[SourceMap] Failed to fetch map for ${chunkName}, status: ${response.status}`);
        return null;
      }
      const rawSourceMap = await response.json();
      consumer = await new SourceMapConsumer(rawSourceMap);
      sourceMapCache.set(chunkName, consumer);
    }
    const originalPosition = consumer.originalPositionFor({ line, column });
    if (!originalPosition.source) {
      return null;
    }
    return originalPosition;
  } catch (err) {
    console.error('Failed to decode map:', err);
    return null;
  }
}
